import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';
import displayUserName from 'src/util/i18n/decorators/displayUserName';

/**
 * Description
 * @param {object} props
 * @param {object} props.propertyUser
 * @param {object} props.intl
 * @returns {React.ReactElement} - AdminPropertyList component
 */
function AdminPropertyShowPropertyUser({ propertyUser = null, intl }) {
  if (!propertyUser) {
    return <Loading />;
  }

  const {
    uuid, externalIdentifier, active, user,
  } = propertyUser;
  const {
    uuid: userId, externalIdentifier: userExternalIdentifier, email: userEmail, active: userActive,
  } = user;

  return (
    <tr>
      <th scope="row" className="text-right">
        <UUID uuid={uuid} url={`/admin/property-users/${uuid}`} />
      </th>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
      <td>{externalIdentifier}</td>
      <th scope="row" colSpan={2}>
        <Link to={`/admin/users/${userId}`}>
          {displayUserName(intl, user)}
          <br />
          {userEmail}
        </Link>
      </th>
      <td>
        <BadgeActiveTimeRange active={userActive} />
      </td>
      <td colSpan={2}>
        <UUID uuid={userId} />
        <br />
        {userExternalIdentifier}
      </td>
    </tr>
  );
}

AdminPropertyShowPropertyUser.propTypes = {
  propertyUser: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default AdminPropertyShowPropertyUser;
